import { useState } from "react";
import "./AppFileNode.css";
import { Card, ChevronDown, Tags } from "../../../ui";

export default function AppFileNode({
  title,
  subtitle,
  status,
  statusVariant = "success",
  children,
  defaultOpen = false,
  id,
  onSelect,
  selected = false,
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Card className={`lud-file-node ${open ? "open" : ""} ${selected ? "is-selected" : ""}`} hoverable={false}>
      <button
        id={id}
        type="button"
        className="lud-file-node__trigger"
        onClick={() => {
          setOpen((v) => !v);
          onSelect?.();
        }}
      >
        <span className="lud-file-node__chevron">
          <ChevronDown size={16} />
        </span>
        <span className="lud-file-node__text">
          <strong>{title}</strong>
          <small>{subtitle}</small>
        </span>
        {status && (
          <Tags variant={statusVariant} size="sm">
            {status}
          </Tags>
        )}
      </button>
      {open && <div className="lud-file-node__children">{children}</div>}
    </Card>
  );
}
